// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_zz4RW","secondaryColumnCell":"secondary-column-cell_zz4RW","body":"body_J7MwL","paper":"paper_RNPjz"};